import React from 'react';
import { AlertOctagon, Sparkles } from 'lucide-react';
import { IconBadge } from '../DarkUI';
import { text, border, brand, status, radius, typography } from '../design-system/tokens';
import { visualDeSeveridad } from '../../utils/kiqDataAdapter';

// KIQ Assistant — Fase 4 — Priority Insights. `insights` ahora puede traer
// resultados REALES del Intelligence Engine (backend/services/kiq/*,
// GET /api/kiq/intelligence/:anio) — este componente NUNCA decide
// severidad ni contenido, solo renderiza EXACTAMENTE lo que el motor ya
// clasificó (sección 12 del pedido: el color es del motor, nunca inferido
// aquí de un número crudo). Sigue respetando la lista vacía tal cual llega
// — nunca sustituye [] por un ejemplo inventado, y el estado vacío honesto
// de Fase 3.1 se conserva sin cambios.
const TOKENS_SEVERIDAD = { danger: status.danger, warning: status.warning, success: status.success, info: brand.kiqBlue };

function TarjetaInsight({ insight }) {
  const visual = visualDeSeveridad(insight.severity);
  const color = TOKENS_SEVERIDAD[visual.token] || brand.kiqBlue;
  return (
    <div style={{ display: 'flex', alignItems: 'flex-start', gap: '10px', padding: '10px 12px', border: `1px solid ${border.default}`, borderRadius: radius.md, background: 'var(--card)' }}>
      <span style={{
        flexShrink: 0, marginTop: '1px', fontSize: '10px', fontWeight: 800, letterSpacing: '.02em',
        color, background: `${color}1F`, border: `1px solid ${color}40`, padding: '2px 7px', borderRadius: radius.pill,
      }}>
        {visual.etiqueta}
      </span>
      <div style={{ minWidth: 0 }}>
        <div style={{ fontSize: '13px', fontWeight: 700, color: text.primary }}>{insight.title}</div>
        <div style={{ fontSize: '12px', color: text.muted, marginTop: '2px', lineHeight: 1.4 }}>{insight.summary}</div>
      </div>
    </div>
  );
}

export default function KIQInsights({ insights = [] }) {
  return (
    <section style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '7px' }}>
        <AlertOctagon size={14} color={status.warning} />
        <h2 style={{ ...typography.title, color: text.primary, margin: 0 }}>Insights prioritarios</h2>
      </div>
      {insights.length === 0 ? (
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '10px', padding: '12px', border: `1px solid ${border.default}`, borderRadius: radius.md, background: 'var(--card-alt)' }}>
          <IconBadge icon={Sparkles} color={brand.kiqBlue} size={26} iconSize={13} />
          <div style={{ minWidth: 0 }}>
            <div style={{ ...typography.bodySmall, color: text.secondary }}>KIQ todavía no ha detectado insights prioritarios.</div>
            <div style={{ fontSize: '11px', color: text.muted, marginTop: '3px', lineHeight: 1.4 }}>Cuando encuentre algo que requiera tu atención, aparecerá aquí.</div>
          </div>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          {insights.map((insight) => <TarjetaInsight key={insight.id} insight={insight} />)}
        </div>
      )}
    </section>
  );
}
